import styled from 'styled-components';
import theme from '../../../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding-top: 36px;

  @media (min-width: 900px) {
    padding-top: 56px;
  }

  & .title {
    font-weight: 500;
    font-size: 22px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;
  }

  .info {
    color: ${theme.colors.colorGray400};
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }
`;
